export default __webpack_public_path__ + "static/media/background.0a6a5633.jpg";